var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconCirlce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.845474,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E2F8E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.775 10.3854C11.1491 11.1645 11.6591 11.8948 12.3049 12.5406C12.9507 13.1864 13.681 13.6964 14.4601 14.0704C14.5271 14.1026 14.5606 14.1187 14.603 14.1311C14.7537 14.175 14.9387 14.1434 15.0663 14.0521C15.1023 14.0263 15.133 13.9956 15.1944 13.9342C15.3823 13.7463 15.4763 13.6523 15.5707 13.5909C15.927 13.3593 16.3864 13.3593 16.7426 13.5909C16.8371 13.6523 16.9311 13.7463 17.119 13.9342L17.2237 14.0389C17.5094 14.3246 17.6522 14.4674 17.7298 14.6208C17.884 14.9258 17.884 15.2861 17.7298 15.5911C17.6522 15.7445 17.5094 15.8873 17.2237 16.173L17.139 16.2577C16.8543 16.5423 16.712 16.6847 16.5185 16.7934C16.3038 16.914 15.9703 17.0007 15.724 17C15.502 16.9993 15.3503 16.9563 15.047 16.8702C13.4166 16.4074 11.8781 15.5343 10.5947 14.2508C9.31117 12.9673 8.43805 11.4289 7.9753 9.79851C7.88919 9.49513 7.84614 9.34344 7.84548 9.12149C7.84475 8.87521 7.93147 8.54171 8.0521 8.32698C8.1608 8.13347 8.30313 7.99114 8.58779 7.70648L8.67251 7.62176C8.95815 7.33612 9.10097 7.1933 9.25436 7.11572C9.55941 6.96143 9.91966 6.96143 10.2247 7.11572C10.3781 7.1933 10.5209 7.33612 10.8066 7.62176L10.9113 7.7265C11.0992 7.9144 11.1931 8.00835 11.2546 8.10283C11.4862 8.45912 11.4862 8.91844 11.2546 9.27472C11.1931 9.3692 11.0992 9.46315 10.9113 9.65106C10.8498 9.7125 10.8191 9.74322 10.7934 9.77913C10.702 9.90674 10.6705 10.0918 10.7144 10.2425C10.7268 10.2849 10.7429 10.3184 10.775 10.3854Z",
    stroke: "#0AC247",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconCirlce);
export default __webpack_public_path__ + "static/media/phoneIconCirlce.9c832b8fb89fb5459f69e1a21166ff98.svg";
export { ForwardRef as ReactComponent };